import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.version;
const version = (state = initialSettings, action) => {
  switch (action.type) {
    case types.UPDATE_PERSIST_STORE_VERSION:
      return {
        ...state,
        persistStore: action.version,
      };
    default:
      return state;
  }
};

export default version;



// WEBPACK FOOTER //
// ./reducers/app/version.js